import React from 'react';
import { Link } from 'react-router-dom';
import './NextSteps.css';
import ApplyLink from './ApplyLink';

const NextSteps: React.FC = () => {
  const steps = [
    {
      number: "1",
      title: "Select a Kitchen",
      description: "Choose from our 5 BC locations that best fits your needs",
      action: "View Locations",
      risk: ""
    },
    {
      number: "2",
      title: "Book a Tour",
      description: "Visit your chosen facility and see your future workspace",
      action: "Schedule Tour",
      risk: ""
    }
  ];

  return (
    <section className="next-steps">
      <div className="container">
        <div className="next-steps-header">
          <h2>Get Started in 2 Simple Steps</h2>
          <p>Join Vancouver's most successful food entrepreneurs</p>
        </div>
        
        <div className="steps-grid">
          {steps.map((step, index) => (
            <div key={index} className="step-card">
              <div className="step-number">{step.number}</div>
              <h3>{step.title}</h3>
              <p>{step.description}</p>
              {step.risk && <div className="step-risk">{step.risk}</div>}
              {step.number === "1" ? (
                <Link 
                  to="/our-kitchens" 
                  className="step-btn"
                  onClick={() => {
                    if (window.gtag) {
                      window.gtag('event', 'click', {
                        event_category: 'Navigation',
                        event_label: 'Next Steps View Locations',
                        value: 1
                      });
                    }
                  }}
                >
                  {step.action}
                </Link>
              ) : (
                <ApplyLink className="step-btn" label="Next Steps Schedule Tour">
                  {step.action}
                </ApplyLink>
              )}
            </div>
          ))}
        </div>
        
        
        <div className="final-cta">
          <h3>Ready to Scale Your Food Business?</h3>
          <p>Join 500+ successful food entrepreneurs at Vancouver's premier shared-use facilities<br/>Launch faster, scale smarter, pay only for what you use</p>
          <div className="cta-buttons">
            <ApplyLink className="btn-primary-large" label="Final CTA Get Started Today">
              Get Started Today
            </ApplyLink>
          </div>
        </div>
      </div>
    </section>
  );
};

export default NextSteps;